import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

function BookingSuccess() {
  const { state } = useLocation();
  const navigate = useNavigate();

  // Redirect if someone opens the page directly
  useEffect(() => {
    if (!state || !state.booking) {
      navigate("/");
    }
  }, [state, navigate]);

  if (!state || !state.booking) return null;

  const booking = state.booking;

  const formatMoney = (value) => {
    if (value == null) return "$0.00";
    const n = Number(value);
    if (Number.isNaN(n)) return `$${value}`;
    return `$${n.toFixed(2)}`;
  };

  const selectedAddons =
    booking.selected_addons ||
    booking.selectedAddons ||
    [];
  const hasAddons = Array.isArray(selectedAddons) && selectedAddons.length > 0;

  const addonsTotal =
    booking.addons_total_amount ??
    booking.addonsTotal ??
    (hasAddons
      ? selectedAddons.reduce((sum, a) => {
          if (!a) return sum;
          const lt = Number(a.line_total ?? a.lineTotal ?? 0);
          if (!Number.isNaN(lt)) return sum + lt;
          const qty = Number(a.quantity ?? 0);
          const up = Number(a.unit_price ?? a.unitPrice ?? 0);
          if (Number.isNaN(qty) || Number.isNaN(up)) return sum;
          return sum + qty * up;
        }, 0)
      : 0);

  const totalAmount =
    booking.total_amount ??
    booking.total ??
    booking.totalAmount ??
    0;

  return (
    <div
      style={{
        padding: "20px",
        maxWidth: "600px",
        margin: "auto",
        textAlign: "center",
      }}
    >
      <h1 style={{ color: "#28a745" }}>Booking Confirmed!</h1>

      <p style={{ marginTop: "10px", fontSize: "18px" }}>
        Your booking has been successfully created.
      </p>

      {/* Booking Details Card */}
      <div
        style={{
          marginTop: "25px",
          padding: "20px",
          border: "1px solid #ddd",
          borderRadius: "10px",
          background: "#fafafa",
          textAlign: "left",
        }}
      >
        <p>
          <strong>Booking ID:</strong> {booking.booking_id || booking.id}
        </p>

        {booking.start_time && (
          <p>
            <strong>Start Time:</strong>{" "}
            {new Date(booking.start_time).toLocaleString()}
          </p>
        )}

        {booking.end_time && (
          <p>
            <strong>End Time:</strong>{" "}
            {new Date(booking.end_time).toLocaleString()}
          </p>
        )}

        {/* Price breakdown */}
        <p>
          <strong>Total Amount:</strong>{" "}
          {formatMoney(totalAmount)}{" "}
          <span style={{ fontSize: "13px", color: "#555" }}>
            (including any add-ons)
          </span>
        </p>

        {hasAddons && (
          <div style={{ marginTop: "10px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
              Add-on amenities:
            </p>
            <ul style={{ paddingLeft: "20px", marginTop: 0 }}>
              {selectedAddons.map((addon, idx) => {
                const label = addon.label || addon.key;
                const qty = addon.quantity ?? 1;
                const lineTotal =
                  addon.line_total ?? addon.lineTotal ?? undefined;
                return (
                  <li key={`${addon.key || idx}-${idx}`}>
                    {label}
                    {qty && qty !== 1 ? ` × ${qty}` : ""}{" "}
                    {lineTotal != null && `– ${formatMoney(lineTotal)}`}
                  </li>
                );
              })}
            </ul>
            <p style={{ marginTop: "4px" }}>
              <strong>Add-ons subtotal:</strong>{" "}
              {formatMoney(addonsTotal)}
            </p>
          </div>
        )}
      </div>

      {/* View My Bookings */}
      <button
        onClick={() => navigate("/my-bookings")}
        style={{
          marginTop: "15px",
          padding: "12px 20px",
          backgroundColor: "#8e44ad",
          color: "white",
          border: "none",
          borderRadius: "8px",
          fontSize: "16px",
          cursor: "pointer",
          display: "block",
          width: "100%",
          maxWidth: "250px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        View My Bookings
      </button>

      {/* Back to Booths */}
      <button
        onClick={() => navigate("/")}
        style={{
          marginTop: "15px",
          padding: "10px 20px",
          backgroundColor: "#3498db",
          color: "white",
          border: "none",
          borderRadius: "8px",
          fontSize: "16px",
          cursor: "pointer",
          display: "block",
          width: "100%",
          maxWidth: "250px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        Find another workspace
      </button>
    </div>
  );
}

export default BookingSuccess;
